import { Button, Flex, Label, Modal, P, Span, styled } from '@fareye/ui'
import { addNewUserCollaborationColors } from '@fareye/configs'
export const IssueRaisedButton = styled(Button)`
  ${(props: any) => {
    return `
      width: 90%;
      display: block;
      color: ${props.theme.colors.blue7};
      background: ${props.theme.colors.blue1};
      margin: 10px auto;
      padding 10px 15px;
    `
  }}
`
export const CustomErrorSpan = styled(Span)`
  ${(props: any) => {
    return `
    font-size: 12px;
    `
  }}
`
export const IssueLabelText = styled(Label)`
  ${(props: any) => {
    return `
    font-size: 14px;
    color: ${addNewUserCollaborationColors['IssueLabelText']};
    letter-spacing:1px;
    `
  }}
`
export const IssueContainerFlex: any = styled(Flex)`
  margin-top: 16px;
  justify-content: space-between;
  align-items: center;
`
export const IssueValueFlex: any = styled(Flex)`
  width: 65%;
`
export const IssueHeadingText = styled(P)`
  font-size: 16px;
  margin-bottom: 10px;
  color: ${addNewUserCollaborationColors['IssueHeadingText']}};
`
export const FaUserCircleStyle = styled(Span)`
  font-size: 18px;
  color: ${(props: any) => props.theme.colors.blue9};
`
export const FaShareContainer = styled(Span)`
  font-size: 14px;
  margin-right: 10px;
  ${(props: any) => props.theme.colors.gray6}
`
export const FaBellContainer = styled(Span)`
  ${(props: any) => {
    return `
    font-size:12px;
    color:${props.color};
    margin:4px;
    `
  }}
`
export const IssueCreatorText = styled(Span)`
  ${(props: any) => {
    return `
    color:${props.theme.colors.blue9};
    text-transform: uppercase;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 5px;
    `
  }}
`
export const CommentText = styled(Span)`
  ${(props: any) => {
    return `
    color:${props.theme.colors.blue9};
    font-size: 14px;
    line-height: 18px;
    `
  }}
`
export const CreatedAtStyle = styled(P)`
  ${(props: any) => {
    return `
    color:${props.theme.colors.grey6};
    font-size: 11px;
    `
  }}
`
export const GroupedButton: any = styled(Flex)`
  width: 100%;
  > * {
    margin: 0;
    border-radius: 0;
    &:nth-child(1) {
      border-radius: 3px 0 0 3px;
    }
    &:last-child {
      border-radius: 0 3px 3px 0;
    }
  }
`

export const Severity = styled.span`
  font-size: 12px;
  color: ${props => props.color};
  font-weight: bold;
`
export const SeverityContainer = styled.div`
  border: 1.5px solid #40a9ff;
  padding: 3px 10px;
  border-radius: 10px;
  outline: none;
  margin-right: 20px;
`

export const ListingContainer = styled(Modal)`
  @media (max-width: 425px) {
    width: 100%;
  }
`

export const Files = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
`

export const FileWrap: any = styled.div`
  position: relative;
  overflow: hidden;
  max-width: 115px;
  background: #f3f3f3;
  border-radius: 2px;
  margin: 5px;
  padding: 3px 15px 3px 5px;
  flex-grow: 1;
  flex-shrink: 1;
  #remove {
    position: absolute;
    top: 4px;
    right: 4px;
  }
  img {
    object-fit: cover;
    height: 50px;
    width: 50px;
  }
`

export const FileWrapDisplay = styled(FileWrap)`
  max-width: 40px;
  padding: 3px 5px;
`

export const fileIconStyle = {
  height: 30,
  width: 23,
  marginRight: 10,
  color: '#adadad'
}

export const CommentContainer: any = styled(Flex)`
  padding: 0.5em;
  background-color: #f0f7fe;
  margin-top: 0.25em;
  border-radius: 10px;
  margin-bottom: 4px;
`
